import React from 'react';
import { FormattedMessage } from 'react-intl';

export const taskCopy = {
  msgOnboarding: (
    <FormattedMessage
      id="task.onboarding.company.notification.msg1"
      defaultMessage="You're using the sample data below. Create your first task and you'll see your data there. Click the button below to create your first task."
    />
  ),
  ctaOnboarding: (
    <FormattedMessage
      id="task.onboarding.company.notification.cta"
      defaultMessage="Create a task"
    />
  ),
  updatePlanMsg: {
    title: (
      <FormattedMessage
        id="company.updateplan.title"
        defaultMessage="Update Plan"
      />
    ),
    msg: (
      <FormattedMessage
        id="company.tasks.updateplan.msg"
        defaultMessage={`Tasks and initiatives aren't available on the Free plan. Please update the plan to unlock this feature.`}
      />
    )
  }
}

export default {
  taskCopy
}